<div class="container">
  <div class="card">
    <h4 class="card-header">
      <a href="#" (click)="$event.preventDefault(); showForm = !showForm">
        <i class="fas" [ngClass]="{ 'fa-minus-circle': showForm, 'fa-plus-circle': !showForm }"></i>
      </a>
      Send Text
    </h4>
    <div class="card-body" [hidden]="!showForm">
      <div class="card border mb-3 border-dark">
        <h5 class="card-header">Send To</h5>
        <div class="card-body">
          <div class="form-group">
            <label> Add Recipient </label>
            <input
              [(ngModel)]="involvementSearchTerm"
              type="text"
              [data]="{ matter_id: matterId }"
              [include_name]="true"
              [appAutocomplete]="'/involvements/autocomplete_contact_by_name'"
              (autocompleteSelect)="recipientOnSelect($event)"
              placeholder="Search for involvement"
              class="form-control"
              name="involvement-search"
            />
            <div class="card mt-1">
              <div class="card-header">
                Recipients - <app-badge badgeType="primary">{{ recipients.length }}</app-badge>
              </div>
              <div class="card-body limited-height-short">
                <div class="py-1 px-1" *ngFor="let recipient of recipients">
                  <a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="removeRecipient(recipient)">
                    <i class="fas fa-times"></i>
                  </a>
                  <span *ngIf="recipient.allow_phone_text && recipient.mobile_present">{{ recipient.label }} <i class="fas fa-mobile-alt fa-fw text-success"></i></span>
                  <span *ngIf="!recipient.allow_phone_text || !recipient.mobile_present">
                    {{ recipient.label }}
                    &nbsp;
                    <i class="fas fa-mobile-alt fa-fw text-danger" [title]="(!recipient.allow_phone_text ? 'Text not allowed' : '') + (!recipient.allow_phone_text && !recipient.mobile_present ? ' ' : '') + (!recipient.mobile_present ? 'No mobile number' : '')"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Load Text Template</label>
        <app-text-template-search (text_document_template_id)="loadTemplate($event)" (clearTextTemplate)="reset()"></app-text-template-search>
      </div>
      <div class="form-row pb-3">
        <div class="col-md-6">
          <label>Text</label>
          <textarea #textArea class="form-control" name="text_content" [(ngModel)]="textContent" placeholder="Text" [maxlength]="maxTextLength"></textarea>
          <small class="form-text text-muted">{{ textContent.length }} / {{ maxTextLength }} characters</small>
        </div>
        <div class="col-md-6">
          <h6>Shortcuts</h6>
          <span *ngFor="let variable of formOptions.variables">
            <span class="badge badge-pill badge-info border border-info" style="cursor: pointer;" (click)="insertAtCursor(variable)" title="Insert at cursor">{{ variable }}</span>
            &nbsp;
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <button type="button" [disabled]="sendingText || savingTemplate || deletingTemplate" class="btn btn-block btn-primary" (click)="sendText()">
            <span *ngIf="!sendingText">Send</span>
            <span *ngIf="sendingText">Sending&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
        <div class="col">
          <button type="button" [disabled]="sendingText || savingTemplate" class="btn btn-block btn-outline-secondary" (click)="reset()">Reset</button>
        </div>
        <div class="col">
          <button type="button" [disabled]="sendingText || savingTemplate || buildingPreview || deletingTemplate" class="btn btn-block btn-outline-info" (click)="previewText()">
            <span *ngIf="!buildingPreview">Preview</span>
            <span *ngIf="buildingPreview">Previewing&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
      </div>
      <div class="form-group" *ngIf="previewResult">
        <div class="card">
          <div class="card-header">Preview</div>
          <div class="card-body">{{ previewResult }}</div>
        </div>
      </div>
      <ng-container *ngIf="canManageTemplates">
        <div class="form-row py-2">
          <div class="col">
            <button type="button" [disabled]="sendingText || savingTemplate || deletingTemplate" class="btn btn-block btn-outline-primary" (click)="saveTemplate()">
              <span *ngIf="!savingTemplate">{{ selectedTemplateId ? 'Update' : 'Save as New' }} Template</span>
              <span *ngIf="savingTemplate">{{ selectedTemplateId ? 'Updating' : 'Saving as New' }} Template&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
          <div class="col" *ngIf="selectedTemplateId">
            <button type="button" class="btn btn-block btn-outline-danger" [disabled]="sendingText || savingTemplate || deletingTemplate" (click)="deleteTemplate()">
              <span *ngIf="!deletingTemplate">Delete Template</span>
              <span *ngIf="deletingTemplate">Deleting Template&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label>Template Name</label>
          <input type="text" class="form-control" name="template_name" [(ngModel)]="templateName" />
          <small class="form-text text-muted">
            <span *ngIf="!selectedTemplateId">New template name for saving a new template</span>
            <span *ngIf="selectedTemplateId">Editing template</span>
          </small>
        </div>
        <div class="form-group">
          <label>Template Description</label>
          <textarea type="text" class="form-control" name="template_description" [(ngModel)]="templateDescription"></textarea>
        </div>
      </ng-container>
    </div>
  </div>
  <br />
  <h3>Texts</h3>
  <pagination
    class="pagination-sm"
    (pageChanged)="loadTextDocuments($event)"
    [boundaryLinks]="true"
    [totalItems]="count"
    [maxSize]="5"
    [(ngModel)]="searchParams.page"
    [itemsPerPage]="searchParams.per_page"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  ></pagination>
  <div *ngIf="loading" class="my-5 py-5 text-center">
    <i class="fas fa-pulse fa-psinner fa-fw fa-5x"></i>
  </div>
  <table class="table" *ngIf="!loading">
    <thead>
      <th>ID</th>
      <th>Direction</th>
      <th>Status</th>
      <th>Date</th>
      <th>Contact</th>
      <th>Text</th>
      <th></th>
    </thead>
    <tbody>
      <ng-container *ngFor="let textDocument of displayTextDocuments">
        <tr [ngClass]="threadRowClass(textDocument)">
          <td>{{ textDocument.id }}</td>
          <td>
            <app-badge [badgeType]="textDocument.direction === 'inbound' ? 'info' : 'secondary'">
              {{ textDocument.direction === 'inbound' ? 'Received' : 'Sent' }}
            </app-badge>
          </td>
          <td>
            <app-badge [badgeType]="(textDocument.status_class || 'secondary')">
              {{ textDocument.service_status }}
            </app-badge>
          </td>
          <td>{{ textDocument.delivered_at_str }}</td>
          <td>{{ textDocument.recipient_str }}</td>
          <td>
            <div class="text-thread-content">
              <div class="text-thread-meta" *ngIf="textDocument.thread_parent_label || textDocument.thread_child_count">
                <span *ngIf="textDocument.thread_parent_label">{{ textDocument.thread_parent_label }}</span>
                <span *ngIf="textDocument.thread_child_count">{{ textDocument.thread_child_count }} {{ textDocument.thread_child_count === 1 ? 'reply' : 'replies' }}</span>
              </div>
              <span>{{ textDocument.text_content }}</span>
              <i *ngIf="textDocument.has_attachment" class="fas fa-paperclip text-muted ml-1" title="Has attachment — see matter history"></i>
            </div>
          </td>
          <td class="text-right">
            <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="sendingReply" *ngIf="textDocument.can_reply" (click)="startReply(textDocument)">
              Reply
            </button>
          </td>
        </tr>
        <tr *ngIf="replyingToTextDocumentId === textDocument.id">
          <td colspan="7">
            <div class="form-row align-items-start">
              <div class="col">
                <textarea class="form-control" [attr.name]="'reply_content_' + textDocument.id" [(ngModel)]="replyContent" placeholder="Reply" [maxlength]="maxTextLength"></textarea>
                <small class="form-text text-muted">{{ replyContent.length }} / {{ maxTextLength }} characters</small>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-primary" [disabled]="sendingReply" (click)="sendReply(textDocument)">
                  <span *ngIf="!sendingReply">Send</span>
                  <span *ngIf="sendingReply">Sending&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                </button>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-outline-secondary" [disabled]="sendingReply" (click)="cancelReply()">Cancel</button>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
